// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoBlock__rl31L {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: var(--tables-primary-row-surface-default);
  border: 1px solid var(--header-stroke);
  padding: 15px;
  row-gap: 16px;
}

.infoTitle__B7g3D {
  font-size: 11px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
  line-height: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.infoTotalBlock__OWQO5 {
  display: flex;
  column-gap: 8px;
}
@media (max-width: 1240px) {
  .infoTotalBlock__OWQO5 {
    flex-direction: column;
    row-gap: 10px;
  }
}

.ytdBlock__d0Ha9 {
  flex: 0 0 35%;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.infoValue__k25r4 {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: var(--legend-for-header-text);
  text-wrap: nowrap;
}

.infoTotalTitle__veFR3 {
  text-wrap: nowrap;
  font-size: 11px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  font-weight: 400;
}

.totalBlock__eNixx {
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.skeletonYtdText__WIpix {
  width: 50px;
  height: 15px;
}

.skeletonTotalText__mJlcS {
  width: 80px;
  height: 15px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/CostSavingsDetails/components/CostSavingInfoBlock/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,qDAAA;EACA,sCAAA;EACA,aAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,yCAAA;EACA,yBAAA;EACA,iBAAA;EAxCA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAqCA,qBAAA;EACA,aAAA;AApEF;;AAuEA;EACE,aAAA;EACA,eAAA;AApEF;AAsEE;EAJF;IAKI,sBAAA;IACA,aAAA;EAnEF;AACF;;AAsEA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAnEF;;AAsEA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,oCAAA;EACA,iBAAA;AAnEF;;AAsEA;EACE,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,yCAAA;EACA,gBAAA;AAnEF;;AAsEA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAnEF;;AAsEA;EACE,WAAA;EACA,YAAA;AAnEF;;AAsEA;EACE,WAAA;EACA,YAAA;AAnEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.infoBlock {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background: var(--tables-primary-row-surface-default);\n  border: 1px solid var(--header-stroke);\n  padding: 15px;\n  row-gap: 16px;\n}\n\n.infoTitle {\n  font-size: 11px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n  line-height: 14px;\n  @include ellipsis-text;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n}\n\n.infoTotalBlock {\n  display: flex;\n  column-gap: 8px;\n\n  @media (max-width: 1240px) {\n    flex-direction: column;\n    row-gap: 10px;\n  }\n}\n\n.ytdBlock {\n  flex: 0 0 35%;\n  display: flex;\n  flex-direction: column;\n  row-gap: 5px;\n}\n\n.infoValue {\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  color: var(--legend-for-header-text);\n  text-wrap: nowrap;\n}\n\n.infoTotalTitle {\n  text-wrap: nowrap;\n  font-size: 11px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  font-weight: 400;\n}\n\n.totalBlock {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  row-gap: 5px;\n}\n\n.skeletonYtdText {\n  width: 50px;\n  height: 15px;\n}\n\n.skeletonTotalText {\n  width: 80px;\n  height: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoBlock": `infoBlock__rl31L`,
	"infoTitle": `infoTitle__B7g3D`,
	"infoTotalBlock": `infoTotalBlock__OWQO5`,
	"ytdBlock": `ytdBlock__d0Ha9`,
	"infoValue": `infoValue__k25r4`,
	"infoTotalTitle": `infoTotalTitle__veFR3`,
	"totalBlock": `totalBlock__eNixx`,
	"skeletonYtdText": `skeletonYtdText__WIpix`,
	"skeletonTotalText": `skeletonTotalText__mJlcS`
};
module.exports = ___CSS_LOADER_EXPORT___;
